import { Helmet } from 'react-helmet-async';

const DEFAULT_DESCRIPTION =
  "Hytch Notification is Hytch Ride's self-hosted notification platform for reliable multi-channel messaging, workflow orchestration, and customer communication operations.";

type Props = {
  title?: string;
  description?: string;
};

export function PageMeta({ title, description }: Props) {
  const pageTitle = title ? `${title} | Hytch Notification` : 'Hytch Notification';
  const pageDescription = description || DEFAULT_DESCRIPTION;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
    </Helmet>
  );
}
